import { render } from "./CreateOpeningHourSideBar.vue?vue&type=template&id=31c8b909"
import script from "./CreateOpeningHourSideBar.vue?vue&type=script&lang=js"
export * from "./CreateOpeningHourSideBar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__